import { faShare } from '@fortawesome/free-solid-svg-icons';
import { useParams } from 'react-router-dom';

import { ContentCard } from 'apps/dashboard/shared/scripts/components';
import { CopyLink, Icon } from 'apps/shared/scripts/components';

import {
  bodyClassName,
  buttonClassName,
  headerClassName,
  headingClassName,
  headingWrapperClassName,
  iconClassName,
  iconWrapperClassName,
  textClassName,
} from './styles';

const CardShare = () => {
  const { cardId } = useParams();
  return (
    <ContentCard>
      <div className={headerClassName}>
        <div className={headingWrapperClassName}>
          <div className={iconWrapperClassName}>
            <Icon className={iconClassName} fa={faShare} />
          </div>
          <h2 className={headingClassName}>Shareable link</h2>
        </div>
      </div>
      <div className={bodyClassName}>
        <CopyLink
          buttonClassName={buttonClassName}
          textClassName={textClassName}
          url={`${process.env.REACT_APP_URL!}/${cardId!}`}
        />
      </div>
    </ContentCard>
  );
};

CardShare.displayName = 'CardShare';

export default CardShare;
